import type { PageList, GeneratePageListOptions } from './types';

function range(start: number, end: number): number[] {
    const length = end - start + 1;
    return Array.from({ length }, (_, i) => start + i);
}

export function generatePageList({
    total,
    currentPage,
    boundaryCount = 1,
    siblingCount = 1,
    ellipsisChar = '...',
}: GeneratePageListOptions): PageList {
    if (total === 0) return [1];

    const startPages = range(1, Math.min(boundaryCount, total));
    const endPages = range(
        Math.max(total - boundaryCount + 1, boundaryCount + 1),
        total,
    );

    const siblingsStart = Math.max(
        Math.min(
            currentPage - siblingCount,
            total - boundaryCount - siblingCount * 2 - 1,
        ),
        boundaryCount + 2,
    );

    const siblingsEnd = Math.min(
        Math.max(
            currentPage + siblingCount,
            boundaryCount + siblingCount * 2 + 2,
        ),
        endPages.length > 0 ? endPages[0] - 2 : total - 1,
    );

    return [
        ...startPages,
        ...(siblingsStart > boundaryCount + 2
            ? [ellipsisChar]
            : boundaryCount + 1 < total - boundaryCount
              ? [boundaryCount + 1]
              : []),
        ...range(siblingsStart, siblingsEnd),
        ...(siblingsEnd < total - boundaryCount - 1
            ? [ellipsisChar]
            : total - boundaryCount > boundaryCount
              ? [total - boundaryCount]
              : []),
        ...endPages,
    ];
}
